import { createFileRoute } from '@tanstack/react-router';

import { SignSupportDetailsRoute } from '@/routes/_authenticated/_management/verkehrszeichen/$adminLevelId/-SignSupportDetailsRoute';

export const Route = createFileRoute('/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: SignSupportDetailsRoute,
});
